<template>
  <div class="error">
    <div class="iconfont icon-gantanhao"></div>
    <div class="title">{{ errorCaption.title }}</div>
    <div class="caption">{{ errorCaption.caption }}</div>
  </div>
</template>
<script type="text/javascript">
import * as Messages from '@/common/utils/messages';

export default {
  data() {
    return {
      errorCaption: {}
    };
  },
  watch: {
    'errorCaption.title': {
      handler: function(title) {
        document.title = title;
        this.$route.meta.title = title;
      },
      immediate: true
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$sn.utils.getHospitalSessionStorage('Homepage_ErrorCaption')) {
      this.$sn.utils.removeHospitalSessionStorage('Homepage_ErrorCaption');
    }
    next();
  },
  mounted() {
    this.$nextTick(() => {
      window.eventBus.$on('Broadcast_NavigatorFunction', () => {
        this.errorCaption = this.$sn.utils.getHospitalSessionStorage('Homepage_ErrorCaption') || {
          title: Messages.C010,
          caption: Messages.C011
        };
      });
    });
  },
  created: function() {
    this.errorCaption = this.$sn.utils.getHospitalSessionStorage('Homepage_ErrorCaption') || {
      title: Messages.C010,
      caption: Messages.C011
    };
  },
  beforeDestroy() {
    window.eventBus.$off('Broadcast_NavigatorFunction');
  }
};
</script>
<style lang="scss" scoped>
.error {
  display: flex;
  flex-direction: column;
  align-items: center;

  .iconfont {
    font-size: 100px;
    color: $text3;
    margin-top: 100px;
    margin-bottom: 20px;
  }

  .title {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .caption {
    @include fs(18);

    width: 60%;
    color: $text3;
    text-align: center;
  }
}
</style>
